import { Component, input, output } from '@angular/core';

import { ButtonModule } from 'primeng/button';

import { NgIcon } from '@ng-icons/core';

import { InjectAttributeDirective } from '@directives/inject-attribute.directive';

import { AnalyticsLabelValuePipe } from '@cxc/ui-kit/pipes';

@Component({
  selector: 'selection-banner',
  standalone: true,
  imports: [
    ButtonModule,
    NgIcon,
    InjectAttributeDirective,
    AnalyticsLabelValuePipe,
  ],
  templateUrl: './selection-banner.component.html',
  styleUrl: './selection-banner.component.scss',
})
export class SelectionBanner {
  selectedCount = input<number>(0);

  selectAll = output<void>();
  clear = output<void>();
  continueClick = output<void>();
}
